<template>
  <div class="footer-column accordion" :class="accordionClasses">
    <h5 class="footer--header accordion-header" @click="toggleAccordion">
      {{ heading }}
    </h5>

    <div class="footer--content accordion-body" :style="accordionBody">
      <div ref="accordionBodyRef">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { isServer } from '@vue-storefront/core/helpers'

export default {
  name: 'FooterAccordion',
  props: {
    heading: {
      type: String,
      required: false,
      default: ''
    },
    content: {
      type: String,
      required: false,
      default: ''
    },
    open: {
      type: Boolean,
      required: false,
      default: null
    }
  },
  methods: {
    toggleAccordion: function () {
      this.isOpen = !this.isOpen;
    },
    scheduleMatchHeight: function () {
      if (isServer || typeof requestAnimationFrame !== 'function') {
        return
      }
      if (this.rafId && typeof cancelAnimationFrame === 'function') {
        cancelAnimationFrame(this.rafId)
      }
      this.rafId = requestAnimationFrame(() => {
        this.matchHeight()
      })
    },
    matchHeight: function () {
      const node = this.$refs.accordionBodyRef
      if (!node) return
      const heightString = node.scrollHeight + 'px';
      this.$set(this.accordionBody, 'max-height', heightString);
    }
  },
  data () {
    return {
      isOpen: false,
      accordionBody: { },
      rafId: null,
      resizeObserver: null
    }
  },
  created () {
    if (this.open) {
      this.isOpen = true
    }
  },
  mounted () {
    this.scheduleMatchHeight();
    if (typeof ResizeObserver !== 'undefined' && this.$refs.accordionBodyRef) {
      this.resizeObserver = new ResizeObserver(() => this.scheduleMatchHeight())
      this.resizeObserver.observe(this.$refs.accordionBodyRef)
    }
  },
  beforeDestroy () {
    if (this.rafId && typeof cancelAnimationFrame === 'function') {
      cancelAnimationFrame(this.rafId)
      this.rafId = null
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
  },
  watch: {
    isOpen () {
      this.scheduleMatchHeight()
    }
  },
  computed: {
    accordionClasses: function () {
      return {
        'is-closed': !this.isOpen
      };
    }
  }
}
</script>
